/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Fireblocks update asset request
 */
export interface FireblocksAssetUpdateRequest {
  fireblocksAssetId: number;
  assetId?: number;
  network?: string;
  feeLevel?: FireblocksAssetUpdateRequest.FeeLevelEnum;
  /**
   * Required if feeLevel=CUSTOM.
   */
  customLevel?: number;
  /**
   * Keep min asset amount during sweep.
   */
  keepMinAmountDuringSweep?: number;
  /**
   * Link if fee asset is different.
   */
  feeFireblocksAssetId?: number;
  /**
   * Min size which would be moved. We don\'t want move small amount - its usually just check before main move.
   */
  minSweepAmount?: number;
  /**
   * Move size, when we need to fill tank for operations. Eg 100 TRX, 0.1 MATIC, 0.01 ETH.
   */
  fuelMoveSize?: number;
  /**
   * If True - asset will be ignored for system log and Slack alerting
   */
  ignore: boolean;
}
export namespace FireblocksAssetUpdateRequest {
  export const FeeLevelEnum = {
    Low: 'LOW',
    Medium: 'MEDIUM',
    High: 'HIGH',
    Custom: 'CUSTOM',
  } as const;
  export type FeeLevelEnum = (typeof FeeLevelEnum)[keyof typeof FeeLevelEnum];
}
